export default (fill) => (
  `<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 103 111" enable-background="new 0 0 103 111" xml:space="preserve">
<g id="Стилеобразующие-элементы-услуг">
	<g id="_x37_" transform="translate(-724.000000, -306.000000)">
		<g id="trudovoe" transform="translate(724.000000, 306.000000)">
			<path id="Fill-1" fill="${fill? fill : '#60bc46'}" d="M101.2,37.4c-0.6-5.7-4.8-13-9.3-16.4c0,0-6.7-5-15.2-10c-8.5-5-16.1-8.4-16.1-8.4
				c-2.6-1.1-5.9-1.7-9.3-1.7c-3.4,0-6.7,0.6-9.3,1.7c0,0-7.6,3.4-16.1,8.4c-8.5,5-15.2,10-15.2,10c-4.5,3.4-8.7,10.7-9.3,16.4
				c0,0-0.9,8.5-0.9,18.4c0,10,0.9,18.4,0.9,18.4c0.6,5.7,4.8,13,9.3,16.4c0,0,6.7,5,15.2,10c8.5,5,16.1,8.4,16.1,8.4
				c2.6,1.1,5.9,1.7,9.3,1.7c3.4,0,6.7-0.6,9.3-1.7c0,0,7.6-3.4,16.1-8.4c8.5-5,15.2-10,15.2-10c4.5-3.4,8.7-10.7,9.3-16.4
				c0,0,0.9-8.5,0.9-18.4C102.1,45.9,101.2,37.4,101.2,37.4L101.2,37.4z M96.6,73.7c-0.5,4.4-3.9,10.5-7.4,13.1
				c-0.1,0-6.7,4.9-14.8,9.7c-8.1,4.8-15.6,8.1-15.6,8.2c-1.9,0.8-4.5,1.3-7.4,1.3c-2.8,0-5.5-0.5-7.4-1.3c-0.1,0-7.5-3.4-15.6-8.2
				c-8.1-4.8-14.7-9.7-14.8-9.7c-3.5-2.6-7-8.7-7.4-13.1c0-0.1-0.9-8.3-0.9-17.9c0-9.6,0.9-17.8,0.9-17.9c0.5-4.4,3.9-10.5,7.4-13.1
				c0.1,0,6.6-4.9,14.8-9.7c8.1-4.8,15.6-8.2,15.6-8.2c1.9-0.8,4.5-1.3,7.4-1.3c2.8,0,5.5,0.5,7.4,1.3c0.1,0,7.5,3.4,15.7,8.2
				c8.1,4.8,14.7,9.7,14.8,9.7c3.5,2.6,7,8.7,7.4,13.1c0,0.1,0.9,8.3,0.9,17.9C97.5,65.4,96.6,73.7,96.6,73.7L96.6,73.7z"/>
			<path fill="${fill? fill : '#60bc46'}" d="M74.9,77.9H27.8c-1.7,0-3.2-1.4-3.2-3.2V42.6c0-1.7,1.4-3.2,3.2-3.2h12.1V30c0-1.7,1.4-3.2,3.2-3.2h16.6
				c1.7,0,3.2,1.4,3.2,3.2v9.4h12.1c1.7,0,3.2,1.4,3.2,3.2v32.2C78.1,76.5,76.6,77.9,74.9,77.9z M28.7,73.9h45.4V63.7
				c-0.1,0-0.2,0-0.3,0h-15v2c0,1.7-1.4,3.2-3.2,3.2h-8.4c-1.7,0-3.2-1.4-3.2-3.2v-2H28.7V73.9z M48,64.8h6.8v-5.2H48V64.8z
				 M58.7,59.7h15c0.1,0,0.2,0,0.3,0V43.4H28.7v16.2H44v-0.9c0-1.7,1.4-3.2,3.2-3.2h8.4c1.7,0,3.2,1.4,3.2,3.2V59.7z M55.6,59.6
				L55.6,59.6L55.6,59.6z M74.9,43.4L74.9,43.4L74.9,43.4z M43.9,39.4h14.9v-8.6H43.9V39.4z M59.7,30.8L59.7,30.8L59.7,30.8z"/>
		</g>
	</g>
</g>
</svg>
`
)


// WEBPACK FOOTER //
// ./components/Icon/icons/uslugas/41.jsx